import { type FC } from "react";
import { type ContactAcquiredModalProps } from "./type";
import { Presentation } from "./Presentation";
import { useContactAcquiredButton } from "./useContactAcquiredButton";

type Props = {
  isPrimary: boolean;
  requestProfilePath: string;
  clientMessageTimelinePagePath: string;
} & ContactAcquiredModalProps;

export const ContactAcquiredButton: FC<Props> = (props) => {
  const { isScout, isSalonTour, requestProfilePath, clientMessageTimelinePagePath } = props;
  const {
    isShow,
    isChecked,
    isPossibleToSubmit,
    handleShowModal,
    handleCloseModal,
    handleChangeCheckbox,
    handleRequestProfile,
  } = useContactAcquiredButton({
    requestProfilePath,
    isScout,
    isSalonTour,
    clientMessageTimelinePagePath,
  });

  return (
    <Presentation
      isShow={isShow}
      isChecked={isChecked}
      isPossibleToSubmit={isPossibleToSubmit}
      handleShowModal={handleShowModal}
      handleCloseModal={handleCloseModal}
      handleChangeCheckbox={handleChangeCheckbox}
      handleRequestProfile={handleRequestProfile}
      {...props}
    />
  );
};
